/**
 * Header order: Medicare item number, Indication, Referred by — each a full-width row.
 * Referred by left the four-column row because GP names run long and were truncated.
 *
 * This seeds a template created or uploaded in the Template editor. Every clinic's LIVE
 * template is stored HTML in `report_templates`, patched separately; this file exists so
 * the next new template does not reintroduce the old order.
 */
export const patientDemographicTable = `
  <div class="report-container">
  <hr/>
    <table data-class="patient-demographic-table">
      <tbody>
        <tr>
          <td><strong>Patient: </strong></td>
          <td><strong>{{patientName}}</strong></td>
          <td><strong>DOB: </strong></td>
          <td><strong>{{dob}}</strong></td>
          <td><strong>Date: </strong></td>
          <td>{{date}}</td>
        </tr>
        <tr>
          <td><strong>Sex: </strong></td>
          <td>{{sex}}</td>
          <td><strong>Patient ID: </strong></td>
          <td>{{patientID}}</td>
          <td><strong>Heart rhythm: </strong></td>
          <td>{{heart_rhythm}}</td>
        </tr>
        <tr>
          <td><strong>HT: </strong></td>
          <td>{{height}}</td>
          <td><strong>WT: </strong></td>
          <td>{{weight}}</td>
          <td><strong>BSA: </strong></td>
          <td>{{bsa}}</td>
        </tr>
        <tr>
          <td><strong>Report Status: </strong></td>
          <td>{{report_status}}</td>
          <td><strong>Heart rate: </strong></td>
          <td>{{heart_rate}}</td>
          <td><strong>BP: </strong></td>
          <td>{{blood_pressure}} mmHg</td>
        </tr>
        <tr>
          <td><strong>Medicare Item number: </strong></td>
          <td colspan="5">{{medicare_item_number}}</td>
        </tr>
        <tr>
          <td><strong>Indication: </strong></td>
          <td colspan="5">{{indication}}</td>
        </tr>
        <tr>
          <td><strong>Referred by: </strong></td>
          <td colspan="5">{{referred_by}}</td>
        </tr>
        <tr>
          <td><strong>Machine: </strong></td>
          <td colspan="5">{{machine_type}}</td>
        </tr>
      </tbody>
    </table>
    <hr/>
  </div>
`;
